import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=4ae3d14c&"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts&"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports